import { useQuoteResults } from 'apps/employer_renewals/providers/QuoteResultsProvider'
import { type RenewalApproach } from 'apps/employer_renewals/types'
import { BorderedRadioButton, Tooltip } from 'slab'
import { type EmployersRenewalsRenewalQuoteResults } from 'utils/web_api.schemas'

export type RenewalApproachOptionsProps = {
  renewalApproach: RenewalApproach
  onRenewalApproachChange: (renewalApproach: RenewalApproach) => void
}

type ApproachOption = {
  title: string
  description: string
  value: RenewalApproach
  disabled?: boolean
  tooltip?: string
}

const getApproachOptions = (quoteResults?: EmployersRenewalsRenewalQuoteResults): ApproachOption[] => {
  return [
    {
      title: 'Reduce benefits',
      description: 'Increase employee out-of-pocket costs to maintain your 2025 spend.',
      value: 'reduce',
      disabled: !quoteResults?.reduced,
    },
    {
      title: 'Maintain benefits level',
      description: 'Maintain the same level of quality and coverage your team had in 2025.',
      value: 'match',
    },
    {
      title: 'Upgrade benefits',
      description: 'Give your team more choice and support with enhanced coverage.',
      value: 'upgrade',
      disabled: !quoteResults?.upgraded,
      tooltip: "You're already offering top tier benefits. Please reach out to support@thatch.com if you'd like to upgrade your benefits even more.",
    },
  ]
}

export default function RenewalApproachOptions ({
  renewalApproach,
  onRenewalApproachChange,
}: RenewalApproachOptionsProps) {
  const { quoteResults } = useQuoteResults()
  const approachOptions = getApproachOptions(quoteResults)

  return (
    <div className='flex flex-col gap-4'>
      <div className='body text-gray-500'>
        Allowance strategy options
      </div>
      <div className='grid gap-3 grid-cols-[repeat(auto-fit,minmax(13rem,1fr))]'>
        {approachOptions.map((option) => (
          <Tooltip
            key={option.value}
            content={option.tooltip}
            enabled={!!option.disabled}
          >
            <div>
              <BorderedRadioButton
                label={option.title}
                description={option.description}
                value={option.value}
                size='large'
                checked={renewalApproach === option.value}
                onChange={() => onRenewalApproachChange(option.value)}
                disabled={option.disabled}
              />
            </div>
          </Tooltip>
        ))}
      </div>
    </div>
  )
}
